import React from "react";
import "./Home.css";

const Home = () => {
  const isMallOfFutureDomain =
    typeof window !== "undefined" && window.location.hostname === "mall.looc.ai";
  const heroImageName = isMallOfFutureDomain
    ? "the-mall-of-future.jpg"
    : "the-dubai-mall-amp-waterfall.jpg";

  return (
    <div className="home">
      <div className="home-hero">
        <div className="hero-image-container">
          <div className="hero-image-placeholder">
            {/* Placeholder for mall image - replace with actual image */}
            <div
              className="hero-image-content"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/${heroImageName})`,
              }}
            >
              <div className="hero-overlay-text">WELCOME</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
